export default __webpack_public_path__ + "static/food_chains-bd0573f0c93b2da3aa6058f0d3494ede.jpg";